import React, { useRef,useEffect  } from 'react';

export default function Spinner(){
    return (
    <div className="personal-backdrop">
        <div className="myspecialSpinner">
            <div className="lds-heart"><div></div></div>
        </div>
    </div>)
}

